import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Button, Stack, Typography, useTheme } from '@monorepo/nova-ui';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export const PayoutConfirmationStage: FunctionComponent<Props> = ({
  onCancel,
  onConfirm,
  isLoading,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation(['withdrawFundsNova']);

  return (
    <Stack width={'100%'} gap={theme.spacing(6)}>
      <Stack gap={theme.spacing(1)}>
        <SystemIcon
          iconName={'DollarNote'}
          size={isMobile ? 84 : 120}
          sx={{
            '& path': {
              fill: `${theme.palette.primary.main} !important`,
            },
            '& path[stroke]': {
              stroke: `${theme.palette.text.opposite} !important`,
            },
            '& path:not([stroke])': {
              stroke: 'none !important',
            },
          }}
        />
        <Typography
          variant={'h3'}
          lineHeight={1}
          color={theme.palette.text.main}
        >
          {t('withdrawFundsNova:confirmation_modal.title')}
        </Typography>
      </Stack>
      <Stack gap={theme.spacing(3)}>
        <Stack>
          <Typography variant={'body1'} color={theme.palette.text.main}>
            {t('withdrawFundsNova:confirmation_modal.message')}
          </Typography>
          <Typography variant={'body1'} color={theme.palette.text.main}>
            {t('withdrawFundsNova:confirmation_modal.program_locked')}
          </Typography>
        </Stack>
        <Typography
          variant={'body1'}
          color={theme.palette.text.main}
          fontWeight={theme.typography.fontWeightMedium}
        >
          {t('withdrawFundsNova:confirmation_modal.question')}
        </Typography>
      </Stack>
      <Stack
        direction={isMobile ? 'column-reverse' : 'row'}
        gap={isMobile ? theme.spacing(4) : theme.spacing(6)}
        width={'100%'}
      >
        <Button
          variant="outlined"
          disabled={isLoading}
          onClick={onCancel}
          sx={{ width: '100%' }}
          size={'lg'}
        >
          {t('withdrawFundsNova:confirmation_modal.cancel')}
        </Button>
        <Button
          variant="primary"
          loading={isLoading}
          disabled={isLoading}
          onClick={onConfirm}
          sx={{ width: '100%' }}
          size={'lg'}
        >
          {t('withdrawFundsNova:confirmation_modal.confirm_button')}
        </Button>
      </Stack>
    </Stack>
  );
};
